module.exports = __webpack_public_path__ + "img/1.58dc39c5.png";